<template>
    <div>

        <div class="row" style="widtgh: 100%">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0; padding-right: 0px; min-height: 60vh;">
              <div class="">
                  <h3 class="mb-0 mt-3 ml-3">Barter Offline Tools</h3>
                  <br>
                  <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(tool, index) in offlineTools" :key="index" :class="[{selected2: selectedOfflineTool == index}]">
                        <div class="row" @click="setOfflineTool(index)">
                            <div class="col-md-8">{{tool.name}}</div>
                            <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                        </div>
                  </div>
              </div>
            </div>
            <div v-if="serverType == 'ho'" class="col-md-9">
                <h3 class="mt-3 ml-3">{{offlineTools[selectedOfflineTool].name}}</h3>
                <div class="row">
                    <a-spin :spinning="downloadSpin">
                        <div class="col-md-12" v-if="selectedOfflineTool == 0" style="padding: 30px; min-height: 63vh;">
                            <a-steps :current="current_0" @change="onChange_0">
                              <a-step title="Step 1" description="Select profiles to extract" />
                              <a-step title="Step 2" description="Configure extraction details" />
                              <a-step title="Step 3" description="Review Configuration & Download" />
                            </a-steps>
                            <div class="col-md-12" v-if="current_0 == 0">
                                <br>
                                <base-input label="Profile Selection">
                                    <br>
                                    <a-select mode="multiple" style="width: 100%" placeholder="" optionFilterProp="children"  v-model="selectedProfiles">
                                      <a-select-option v-for="(profile, index) in profiles" :key="index" :value="profile">{{ _.startCase(profile)}}</a-select-option>
                                    </a-select>
                                    <small><span class="fa fa-info-circle text-blue"/> These are the profiles that will be part of the zip file to be downloaded after the configuration.</small>
                                </base-input>
                            </div>
                            <div class="col-md-12" v-if="current_0 == 1">
                                <br>
                                <base-input v-if="false" label="Configuration">
                                    <br>
                                    <div v-if="false">
                                        <a-switch checked-children="Full Export" un-checked-children="Full Export" v-model="fullExport"/> <br>
                                        <small><span class="fa fa-info-circle text-blue"/> If this option is enabled, full copy of the selected profiles will be exported.</small>
                                    </div>
                                </base-input>
                                <div v-if="fullExport == false">
                                    <base-input label="Export updated profiles starting from:">
                                        <a-date-picker v-model="lastUpdateDate" format="YYYY-MM-DD" placeholder="Date" style="width:100%"/>
                                    </base-input>
                                </div>
                                <div v-if="serverType == 'ho'">
                                    <base-input label="Site Selection">
                                        <a-select style="width: 100%" showSearch placeholder="" optionFilterProp="children"  v-model="selectedSite">
                                          <a-select-option v-for="(site, index) in sites" :key="index" :value="site.id">{{site.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                                <div>
                                    <base-input label="Validity Date">
                                        <br>
                                        <a-range-picker v-model="profileDateRange" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width:70%"/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="current_0 == 2">
                                <br>
                                <h6 class="text-muted">Export Details</h6>
                                <small>
                                    <div v-if="fullExport"> <b>Export Mode:</b> Full Export </div>
                                    <div v-else>
                                        <b>Export Mode:</b> Delta Export  <br>
                                        <b>Export updated profiles starting from:</b> {{this.lastUpdateDate.format("YYYY-MM-DD")}}
                                    </div>
                                    <div v-if="serverType == 'ho'"><b>Site:</b> {{selectedSiteName}} <br></div>
                                    <div><b>Validity Date:</b> {{validatityDateFormat(profileDateRange[0])}} - {{validatityDateFormat(profileDateRange[1])}} <br></div>
                                    <b>Profiles to export:</b> &nbsp;
                                    <template v-for="(tag, index) in selectedProfiles">
                                        <a-tag :key="index" color="blue">{{ tag }}</a-tag>
                                    </template> <br>
                                    <div class="note">
                                      <b>Note: </b>
                                      <span>After clicking the Download Button, it will generate the Full Export file and download it to your local computer or device.</span>
                                    </div>
                                </small>
                            </div>
                        </div>
                    </a-spin>

                      <SalesUploader v-if="selectedOfflineTool == 1"/>

                    <div class="col-md-12" v-if="selectedOfflineTool == 2" style="padding: 30px;">
                        <a-steps :current="current_2" @change="onChange">
                          <a-step title="Step 1" description="Upload JSON File" />
                          <a-step title="Step 2" description="Review Details" />
                          <a-step title="Step 3" description="Process File" />
                        </a-steps>
                    </div>
                    <div v-if="selectedOfflineTool != 1"
                         class="col-md-12"
                         style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
                        <div class="steps-action float-right">
                            <a-button v-if="current_0 > 0" @click="prevStep(selectedOfflineTool)">
                                Previous
                            </a-button>
                            <a-button v-if="current_0 < maxStep" type="primary" @click="nextStep(selectedOfflineTool)" style="margin-left: 8px">
                                Next
                            </a-button>
                            <a-button
                                v-if="current_0 == maxStep"
                                type="primary"
                                style="margin-left: 8px"
                                @click.prevent="proceed"
                            >
                                Download
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="serverType == 'branch'" class="col-md-9">
                <h3 class="mt-3 ml-3">{{offlineTools[selectedOfflineTool].name}}</h3>
                <!-- <div class="row"> -->
                    <a-spin  v-if="selectedOfflineTool == 0" :spinning="downloadSpin">
                        <div class="col-md-12" v-if="selectedOfflineTool == 0" style="padding: 30px; height: 64vh; width: 100%;">
                            <a-steps :current="current_0" @change="onChange_0">
                              <a-step title="Step 1" description="Select profiles to extract" />
                              <a-step title="Step 2" description="Configure extraction details" />
                              <a-step title="Step 3" description="Review & Download" />
                            </a-steps>
                            <div class="col-md-12" v-if="current_0 == 0">
                                <br>
                                <base-input label="Profile Selection">
                                    <br>
                                    <a-select mode="multiple" style="width: 100%" placeholder="" optionFilterProp="children"  v-model="selectedProfiles">
                                      <a-select-option v-for="(profile, index) in profiles" :key="index" :value="profile">{{ _.startCase(profile)}}</a-select-option>
                                    </a-select>
                                    <small><span class="fa fa-info-circle text-blue"/> These are the profiles that will be part of the zip file to be downloaded after the configuration.</small>
                                </base-input>
                            </div>
                            <div class="col-md-12" v-if="current_0 == 1">
                                <br>
                                <base-input label="Configuration">
                                    <br>
                                    <a-switch checked-children="Full Export" un-checked-children="Full Export" v-model="fullExport"/> <br>
                                    <small><span class="fa fa-info-circle text-blue"/> If this option is enabled, full copy of the selected profiles will be exported.</small>
                                </base-input>
                                <div v-if="fullExport == false">
                                    <base-input label="Export updated profiles starting from:">
                                        <a-date-picker v-model="lastUpdateDate" format="YYYY-MM-DD" placeholder="Date" style="width:100%"/>
                                    </base-input>
                                </div>
                                <div v-if="serverType == 'ho'">
                                    <base-input label="Site Selection">
                                        <a-select style="width: 100%" placeholder="" optionFilterProp="children"  v-model="selectedSite">
                                          <a-select-option v-for="(site, index) in sites" :key="index" :value="site.id">{{site.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="current_0 == 2">
                                <br>
                                <h6 class="text-muted">Export Details</h6>
                                <small>
                                    <div v-if="fullExport"> <b>Export Mode:</b> Full Export </div>
                                    <div v-else>
                                        <b>Export Mode:</b> Delta Export  <br>
                                        <b>Export updated profiles starting from:</b> {{this.lastUpdateDate.format("YYYY-MM-DD")}}
                                    </div>
                                    <div v-if="serverType == 'ho'"><b>Site:</b> {{selectedSiteName}} <br></div>
                                    <b>Profiles to export:</b> &nbsp;
                                    <template v-for="(tag, index) in selectedProfiles">
                                        <a-tag :key="index" color="blue">{{ tag }}</a-tag>
                                    </template> <br>
                                </small>
                            </div>
                        </div>
                    </a-spin>

                    <a-spin  v-if="selectedOfflineTool == 1" :spinning="downloadSpin">
                        <div class="col-md-12" style="padding: 30px; height: 64vh; width: 100%;">
                            <a-steps :current="current_0" @change="onChange">
                              <a-step title="Step 1" description="Upload zip file" />
                              <a-step title="Step 2" description="Review files" />
                              <a-step title="Step 3" description="Process files" />
                            </a-steps>
                            <div v-if="current_0 == 0">
                                <br>
                                <!-- <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload" -->
                                <a-upload-dragger :multiple="false">
                                    <span class="fa fa-file-import" style="font: 20pt;" />
                                    <p class="ant-upload-text">Click or drag file to this area to upload</p>
                                    <p class="ant-upload-hint">
                                        Upload your zip file downloaded from HO.
                                    </p>
                                </a-upload-dragger>
                            </div>
                            <div v-if="current_0 == 1">
                                <br>
                                <h6 class="text-muted">Upload Review</h6>
                                <small>
                                    <b>Total Files:</b> 2
                                </small>
                                <!-- <a-directory-tree multiple default-expand-all @select="onSelect" @expand="onExpand"> -->
                                <a-directory-tree multiple default-expand-all checkable>
                                  <a-tree-node key="0-0" title="Zip File">
                                    <a-tree-node key="0-0-0" title="baggers.csv" is-leaf />
                                    <a-tree-node key="0-0-1" title="products.csv" is-leaf />
                                  </a-tree-node>
                                </a-directory-tree>

                            </div>
                        </div>
                    </a-spin>

                    <a-spin  v-if="selectedOfflineTool == 2" :spinning="downloadSpin">
                        <div class="col-md-12" v-if="selectedOfflineTool == 2" style="padding: 30px; height: 64vh; overflow: scroll;">
                            <a-steps :current="current_0" @change="onChange">
                              <a-step title="Step 1" description="Configure extraction details" />
                              <a-step title="Step 2" description="Review & Download" />
                            </a-steps>
                            <div class="col-md-12" v-if="current_0 == 0">
                                <br>
                                 <base-input label="Export Mode">
                                    <br>
                                    <a-switch v-model="salesExportMode"/> <small> &nbsp; Export All Unsent Sales </small> <br>
                                    <small><span class="fa fa-info-circle text-blue"/> Disable this setting if you want to export specific business dates or transactions only.</small>
                                </base-input>
                                <div v-if="salesExportMode == false">
                                    <a-switch v-model="transactionSpecific"/> <small> &nbsp; Export Specific Transaction Only </small> <br><br>
                                    <div v-if="transactionSpecific == true">
                                        <base-input v-model="transactionNo" label="Transaction ID" type="text" />
                                        <base-input label="Terminal Selection">
                                            <a-select style="width: 100%" placeholder="" optionFilterProp="children"  v-model="selectedTerminal">
                                              <a-select-option v-for="(terminal, index) in terminals" :key="terminal.id" :value="terminal.id">{{terminal.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                    <div v-if="transactionSpecific == false">
                                        <base-input label="Business Date Range">
                                            <br>
                                            <a-range-picker v-model="salesDateRange" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width:70%"/>
                                        </base-input>
                                        <base-input label="Sales Flag">
                                            <br>
                                            <a-switch v-model="unsentFlag"/> <small> &nbsp; Export Unsent Sales Only </small> <br>
                                            <small><span class="fa fa-info-circle text-blue"/> Disble this setting if you want to include even the sent sales in the exportation. </small>
                                        </base-input>
                                    </div>
                                </div>
                                <br>
                            </div>
                            <div class="col-md-12" v-if="current_0 == 1">
                                <br>
                                <h6 class="text-muted">Extraction Configuration</h6>
                                <small>
                                    <div v-if="salesExportMode == true"><b>Export Mode:</b>  Export All Unsent</div>
                                    <div v-else>
                                        <b>Export Mode:</b>  Selected Export <br>
                                        <div v-if="transactionSpecific == true">
                                            <b>Transaction No: </b> {{transactionNo}} <br>
                                            <b>Terminal: </b> {{selectedTerminalName}}
                                        </div>
                                        <div v-else>
                                            <b>Date Range:</b>  {{salesDateRange[0].format("YYYY/MM/DD")}} - {{salesDateRange[1].format("YYYY/MM/DD")}}<br>
                                            <div v-if="unsentFlag == true"><b>Sales Flag:</b>  Export Unsent Sales Only <br></div>
                                            <div v-else><b>Sales Flag:</b>  Export All Sales <br></div>
                                        </div>
                                    </div>
                                </small>
                                <br><br>
                            </div>
                        </div>
                    </a-spin>

                     <a-spin  v-if="selectedOfflineTool == 3" :spinning="downloadSpin">
                        <div class="col-md-12" style="padding: 30px; height: 64vh; width: 100%;">
                            <a-steps :current="current_0" @change="onChange">
                              <a-step title="Step 1" description="Upload JSON file" />
                              <a-step title="Step 2" description="Review Sales Data" />
                              <a-step title="Step 3" description="Process JSON file" />
                            </a-steps>
                            <div v-if="current_0 == 0">
                                <br>
                                <!-- <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload" -->
                                <a-upload-dragger :multiple="false">
                                    <span class="fa fa-file-import" style="font: 20pt;" />
                                    <p class="ant-upload-text">Click or drag file to this area to upload</p>
                                    <p class="ant-upload-hint">
                                        Upload your JSON file extracted from source here.
                                    </p>
                                </a-upload-dragger>
                            </div>
                            <div v-if="current_0 == 1">
                                <br>
                                <h6 class="text-muted">Upload Review</h6>
                                <small>
                                    <b>Total Sales Data:</b> 2 <br>
                                    <b>Terminal:</b> jj-1 <br>
                                    <b>Business Date Range:</b> 2020/06/01 - 2020/06/02 <br>
                                </small>
                            </div>
                        </div>
                    </a-spin>

                    <div v-if="selectedOfflineTool != 1"
                         class="col-md-12"
                         style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
                        <div class="steps-action float-right">
                            <a-button v-if="current_0 > 0" @click="prevStep">
                                Previous
                            </a-button>
                            <a-button v-if="current_0 < maxStep" type="primary" @click="nextStep" style="margin-left: 8px">
                                Next
                            </a-button>
                            <a-button
                                v-if="current_0 == maxStep"
                                type="primary"
                                style="margin-left: 8px"
                                @click.prevent="proceed"
                            >
                                Proceed
                            </a-button>
                        </div>
                        </div>
                    </div>

                </div>
            <!-- </div> -->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage.js';
import axios from "axios";
import moment from 'moment';
import SalesUploader from '../POS Admin Tools/SalesUploader';

export default {
    components: {
      SalesUploader
    },
    computed: {
        ...mapState(['serverType', 'endPoint'])
    },
    watch: {
        selectedSite: function() {
            this.setSelectedSiteName();
        },
        selectedTerminal: function() {
            this.terminals.map( x=> { if(x.id == this.selectedTerminal) this.selectedTerminalName = x.name })
        }
    },
    mounted: async function(){
        // Get all sites of current account with active Terminals
        var sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_sites_with_terminal', null, null)
        this.sites = sites

        // Get All terminals of current Site
        var terminals = await HTTPRequest.getRequest(this.endPoint + 'terminals?site_id=' + secureStorage.getItem('defaultSiteId') , null, null)
        this.terminals = terminals.data

        // Get Full Sync Default Profiles
        const profileRequest = await HTTPRequest.getRequest(`${this.endPoint}systems/full_sync/default_full_sync_profiles`, null, null)
        this.profiles = profileRequest ? profileRequest.profiles : this.profiles;

        this.selectedProfiles = this.profiles
        if(this.serverType == 'ho'){
            this.offlineTools = [ {name: "Profile Extractor"}, {name: "Sales Uploader"}, {name: "Documents Uploader"}]
        } else {
            this.offlineTools = [ {name: "Profile Extractor"}, {name: "Profile Uploader"}, {name: "Sales Extractor"}, {name: "Sales Uploader"}, {name: "Documents Extractor"}]
        }

        this.setSelectedSiteName();
    },
    data: function(){
        return {
            offlineTools: [ {name: "Profile Extractor"}, {name: "Profile Uploader"}, {name: "Sales Extractor"}, {name: "Sales Uploader"}, {name: "Documents Extractor"}, {name: "Documents Uploader"}],
            selectedOfflineTool: 0,
            current_0: 0,
            current_1: 0,
            current_2: 0,
            profiles: ["baggers", "bank_cards", "banks", "categories", "customers", "products", "reason_types", "reasons", "salesmen", "users"],
            selectedProfiles: [],
            maxStep: 2,
            fullExport: true,
            sites: [],
            selectedSite: secureStorage.getItem("defaultSiteId"),
            selectedSiteName: null,
            lastUpdateDate: moment(),
            downloadSpin: false,
            unsentFlag: true,
            salesExportMode: true,
            salesDateRange: [moment(), moment()],
            profileDateRange: [moment(), moment()],
            transactionSpecific: false,
            transactionNo: null,
            terminals: [],
            selectedTerminal: null,
            selectedTerminalName: null,
        }
    },
    methods: {
        setSelectedSiteName() {
            this.sites.map( x=> { if(x.id == this.selectedSite) this.selectedSiteName = x.name })
        },
        prevStep(){
            this.current_0--;
        },
        nextStep(){
            if(this.current_0 == 0 && this.selectedOfflineTool == 0){
                var checker = this.selectedProfiles.length
                if(checker > 0){
                    this.current_0++;
                } else {
                    this.$notification['error']({
                      message: 'Cannot proceed to next step',
                      description: "Please input profiles for exportation."
                    });
                }
            } else {
                this.current_0++;
            }

        },
        validatityDateFormat(date) {
          return moment(date).format('MM-DD-YYYY');
        },
        checkErrors() {
          if (this.selectedOfflineTool == 0) {
            if (!this.selectedSite) {
              this.$notification['error']({
                message: 'Export Error',
                description: "Please select a Site"
              });
              return true;
            }
          }

          return false;
        },
        async proceed(){
            const hasError = this.checkErrors();

            if (hasError) { return; }

            if(this.selectedOfflineTool == 0){
                this.downloadSpin = true
                var syncPayload = {}
                const valid_from = moment(this.profileDateRange[0]).format('YYYY-MM-DD');
                const valid_to = moment(this.profileDateRange[1]).format('YYYY-MM-DD');
                if(this.serverType == 'ho') {
                    syncPayload = {
                        site_id: this.selectedSite,
                        profiles: this.selectedProfiles,
                        mode: this.fullExport,
                        date: this.lastUpdateDate,
                        valid_from: valid_from,
                        valid_to: valid_to
                    }
                } else {
                    syncPayload = {
                        site_id: null,
                        profiles: this.selectedProfiles,
                        mode: this.fullExport,
                        date: this.lastUpdateDate,
                        valid_from: valid_from,
                        valid_to: valid_to
                    }
                }
                // var sites = await HTTPRequest.postRequest(this.endPoint + 'manual_extract', null, syncPayload)
              var downloadFile = await axios({
                method: 'post',
                // responseType: 'blob', // important
                url: this.endPoint + "systems/full_sync/manual_extract",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", "Request-Source": "BXI-File" },
                data: syncPayload
              })
              // const url = window.URL.createObjectURL(new Blob([downloadFile.data], {type: 'application/zip'}));
              // const link = document.createElement('a');
              // link.href = url;
              // const site = this.sites.filter( x => x.id == this.selectedSite)[0];
              // let site_code = site ? site.refcode || site.code : ''
              // const extraction_date = moment().format('YYYY_MM_DD');
              // link.setAttribute('download', `${site_code}_full_sync_profiles_${extraction_date}.zip`);
              // document.body.appendChild(link);
              // link.click();
              // window.URL.revokeObjectURL(url);
              // this.$notification['success']({
              //     message: 'Successful Download',
              //     description: "You have succesfully downloaded the file."
              // });

              this.$notification['success']({
                message: 'Successful Operation',
                description: "Export has been added to Job Monitoring. Check the ongoing jobs for status update.",
              });

              this.downloadSpin = false
              this.current_0 = 0
              this.selectedSite = secureStorage.getItem("defaultSiteId")
              this.selectedSiteName = null
              this.setSelectedSiteName();
              this.selectedProfiles = this.profiles
              this.lastUpdateDate = moment()
            }
            if(this.selectedOfflineTool == 2){
                this.downloadSpin = true
                var syncPayload = {}
                if(this.salesExportMode)
                    syncPayload = { mode: this.salesExportMode }
                else{
                    if(this.transactionSpecific == true){
                        syncPayload = { mode: null, transaction_no: this.transactionNo, terminal_id: this.selectedTerminal }
                    } else {
                        syncPayload = { mode: this.salesExportMode, from: this.salesDateRange[0].format("YYYY-MM-DD"), to: this.salesDateRange[1].format("YYYY-MM-DD"), sales_flag: this.unsentFlag }
                    }
                }

                // var sites = await HTTPRequest.postRequest(this.endPoint + 'manual_extract', null, syncPayload)
                var downloadFile = await axios({
                    method: 'post',
                    responseType: 'blob', // important
                    url: this.endPoint + "sales_manual_extract",
                    headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"},
                    data: syncPayload
                })
                // console.log("-------------");
                // console.log(downloadFile);
                if(downloadFile.status == 200){
                    const url = window.URL.createObjectURL(new Blob([downloadFile.data], {type: 'application/zip'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales.json');
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    this.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the file."
                    });
                } else {
                    this.$notification['info']({
                        message: 'Nothing to export',
                        description: "No sales matched your selected filter"
                    });
                }

                this.downloadSpin = false
                this.current_0 = 0
            }
        },
        setOfflineTool(index){
            this.current_0 = 0
            this.selectedOfflineTool = index;
            if(this.selectedOfflineTool == 2){
                this.maxStep = 1;
            }else{
                this.maxStep = 2;
            }
        },
        onChange_0(current) {
          this.current_0 = current;
        },
        onChange(current) {
          if(this.serverType == 'branch'){
              if(this.selectedOfflineTool == 2){
                  this.current_2 = current;
              }
          }
        },
    }
}
</script>

<style>
  .selected2{
    background-color:  #EFF6FF;
    color: #2371CC;
  }

  .note {
    font-style: italic;
    margin-top: 10px;
  }
</style>
